import { cn } from '@nesso/ui/lib/utils';
import { Card } from '@nesso/ui/primitives/card';

type Props = {
    children: React.ReactNode;
    className?: string;
    size?: 'default' | 'narrow' | 'medium';
};

const sizeClasses = {
    // Sign-in / sign-up card — Figma 2438-907 (650px wide, 80px padding).
    default: 'sm:max-w-xl md:max-w-162.5 sm:px-20 sm:py-14',
    // Locked / unlock screens — Figma 2438-1720 / 2560-1006 (504px wide, 56px padding).
    narrow: 'sm:max-w-126 sm:px-14 sm:py-14',
    medium: 'sm:max-w-150.5 sm:p-14',
} as const;

export function AuthCard({ children, className, size = 'default' }: Props) {
    return <Card className={cn('w-full px-6 py-8', sizeClasses[size], className)}>{children}</Card>;
}
